import axios from 'axios';
import Bowser from 'bowser';
import { get } from 'lodash';
import { CONTENT_EVENTS } from '@upsolve/shared';

interface IComponentImpressionEvent {
  eventType: string;
  deviceId: string;
  eventProperties: {
    browser?: {
      name: string;
      version: string;
    };
    canonicalUrl?: string;
    componentName: string;
    componentVersion: string;
    os?: {
      name: string;
      version: string;
      versionName: string;
    }
    path?: string;
    platform?: {
      type: string;
      vendor: string;
    };
    screenHeight?: number;
    screenWidth?: number;
    scrollPosition?: number;
    url?: string;
  };
}

export default async function trackComponentImpression({
  componentName,
  componentVersion,
}: IComponentImpressionEvent["eventProperties"]) {
  if (componentName == null) throw new Error('Missing Component Name');
  if (componentVersion == null) throw new Error('Missing Component Version');

  const anonymousId = get(window, 'analytics.user') != null
    ? window.analytics.user().anonymousId()
    : null;

  try {
    const browserProps = Bowser.parse(window.navigator.userAgent);
    const trackBody: IComponentImpressionEvent = {
      eventType: CONTENT_EVENTS.COMPONENT_IMPRESSION,
      deviceId: anonymousId,
      eventProperties: {
        browser: browserProps.browser,
        canonicalUrl: get(document.querySelector('link[rel="canonical"]'), 'href'),
        componentName,
        componentVersion,
        os: browserProps.os,
        path: window.location.pathname,
        platform: browserProps.platform,
        screenHeight: window.innerHeight,
        screenWidth: window.innerWidth,
        scrollPosition: Math.round(window.scrollY),
        url: window.location.href,
      }
    };
    await axios.post(`${UPSOLVE_API_URL}/v1/tracking/frontdoor`, trackBody);
  } catch (error) {
    console.warn(error);
  }
}
